import {
  apiLockedSelector,
  appMessageSelector,
  canNotReactivateSelector,
} from '../data/company.js'
import {currentPageSelector} from '../redux/selectors/ui/index.js'

import WebSockets from '../common/components/WebSockets.js'
import CurrentDropdownListener from '../common/components/CurrentDropdownListener.js'
import PrintNodeListener from '../common/components/PrintNodeListener.js'
import Zuck from '../common/components/Zuck.js'
import CreateOrderLocationListener from './CreateOrderPage/CreateOrderLocationListener.js'
import OrderDetailLocationListener from './OrderDetailPage/OrderDetailLocationListener.js'
import HotKeys from '../common/components/HotKeys.js'
import ProductListLocationListener from './ProductListPage/ProductListLocationListener.js'
import PODetailLocationListener from './PurchaseOrderDetailPage/PODetailLocationListener.js'
import POListLocationListener from './PurchaseOrderListPage/POListLocationListener.js'
import ReportsPageLocationListener from './ReportsPage/ReportsPageLocationListener.js'
import ReturnOrderListLocationListener from './ReturnOrderListPage/ReturnOrderListLocationListener.js'
import ReturnOrderDetailLocationListener from './ReturnOrderDetailPage/ReturnOrderDetailLocationListener.js'
import CurrentDateListener from './CurrentDateListener.js'
import MOListLocationListener from './MOListPage/MOListLocationListener.js'
import MODetailLocationListener from './MODetailPage/MODetailLocationListener.js'
import AnalyticsLocationListener from './AnalyticsPage/AnalyticsLocationListener.js'
import BatchListLocationListener from './BatchListPage/BatchListLocationListener.js'

import Header from './Header/index.js'
import ProgressIndicator from './Header/ProgressIndicator.js'
import AppHashListener from './AppHashListener.js'
import Modals from './Modals/index.js'
import Main from './Main.js'
import GlobalErrorMessage from './GlobalErrorMessage.js'
import QueryCall from '../common/components/QueryCall.js'
import OrderListLocationListener from './OrderListPage/OrderListLocationListener.js'
import {CALL_UP_PAGE} from '../common/constants/Pages.js'
import CallUpPage from './CallUpPage/index.js'
import CallUpLocationListener from './CallUpPage/CallUpLocationListener.js'
import Theme from '../common/components/Theme.js'
import DashboardLocationListener from './DashboardPage/DashboardLocationListener.js'
import WelcomeLocationListener from './WelcomePage/WelcomeLocationListener.js'
import PackShipLocationListener from './PackShipPage/PackShipLocationListener.js'
import StocktakeListLocationListener from './StocktakeListPage/StocktakeListLocationListener.js'
import StocktakeDetailLocationListener from './StocktakeDetailPage/StocktakeDetailLocationListener.js'
import SettingsLocationListener from './Settings/SettingsLocationListener.js'
import DataImportLocationListener from './dataImport/DataImportLocationListener.js'
import ProductDetailLocationListener from './ProductDetailPage/ProductDetailLocationListener.js'
import Data, {
  hasBegunLoadingDataSelector,
  isDoneLoadingDataSelector,
  loadingDataErrorSelector,
} from '../data/Data.js'
import {useSelector} from '../store.js'
import AppLoadErrorMessage from './AppLoadErrorMessage.js'
import TaskListener from './Header/ActivityMenu/TaskListener.js'
import TransferListLocationListener from './TransferListPage/TransferListLocationListener.js'
import TransferDetailLocationListener from './TransferDetailPage/TransferDetailLocationListener.js'

function hasBlockingAppMessageSelector(state) {
  const appMessage = appMessageSelector(state)
  const hasBegunLoadingData = hasBegunLoadingDataSelector(state)

  return appMessage && (!appMessage.canDismiss || !hasBegunLoadingData)
}

function showMainSelector(state) {
  const hasBlockingAppMessage = hasBlockingAppMessageSelector(state)
  const canNotReactivate = canNotReactivateSelector(state)
  const isDoneLoadingData = isDoneLoadingDataSelector(state)

  return !hasBlockingAppMessage && !canNotReactivate && isDoneLoadingData
}

export default function App() {
  const apiLocked = useSelector(apiLockedSelector)
  const showMain = useSelector(showMainSelector)
  const currentPage = useSelector(currentPageSelector)
  const loadingDataError = useSelector(loadingDataErrorSelector)

  return (
    <div className="app">
      <Data />
      <WebSockets />
      {loadingDataError ? (
        <AppLoadErrorMessage />
      ) : apiLocked ? (
        <>
          <GlobalErrorMessage />
          <Modals />
        </>
      ) : currentPage === CALL_UP_PAGE ? (
        <>
          <CallUpLocationListener />
          <CallUpPage />
        </>
      ) : (
        <>
          <QueryCall />
          <CallUpLocationListener />
          <WelcomeLocationListener />
          <DashboardLocationListener />
          <CreateOrderLocationListener />
          <AppHashListener />
          <AnalyticsLocationListener />
          <DataImportLocationListener />
          <OrderDetailLocationListener />
          <PackShipLocationListener />
          <ProductListLocationListener />
          <ProductDetailLocationListener />
          <POListLocationListener />
          <PODetailLocationListener />
          <ReportsPageLocationListener />
          <ReturnOrderListLocationListener />
          <ReturnOrderDetailLocationListener />
          <MOListLocationListener />
          <MODetailLocationListener />
          <BatchListLocationListener />
          <OrderListLocationListener />
          <SettingsLocationListener />
          <StocktakeListLocationListener />
          <StocktakeDetailLocationListener />
          <TransferListLocationListener />
          <TransferDetailLocationListener />
          <TaskListener />
          <HotKeys />
          <CurrentDropdownListener />
          <CurrentDateListener />
          <PrintNodeListener />
          <GlobalErrorMessage />
          <Modals />
          <Zuck />
          <Theme />
          <div className="wrap--header">
            <Header />
            <ProgressIndicator />
          </div>
          {showMain && <Main />}
        </>
      )}
    </div>
  )
}
